import {
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
import { useMemo } from "react";

const BLOCKED_TYPES = new Set(["final", "hired"]);

export const useStatusReorder = (statuses, onPositionUpdate) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
  );

  const statusTypeById = useMemo(
    () => Object.fromEntries(statuses.map((s) => [s.id, s.type])),
    [statuses],
  );

  const collisionDetection = (args) => {
    const validContainers = args.droppableContainers.filter(
      (c) => !BLOCKED_TYPES.has(statusTypeById[c.id]),
    );
    return closestCenter({ ...args, droppableContainers: validContainers });
  };

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    const ids = statuses.map((s) => s.id);
    const newOrder = arrayMove(
      ids,
      ids.indexOf(active.id),
      ids.indexOf(over.id),
    );
    const newIndex = newOrder.indexOf(active.id);

    if (newIndex === 0) return;

    onPositionUpdate(newOrder[newIndex - 1]);
  };

  return { sensors, collisionDetection, handleDragEnd };
};
